<template>
    <div class="side-menu side-menu-el">
        <div class="inner">
            <div class="heading">
                <button class="open-close-button arrowed-link" @click="closeMenu()">
                    <span>Lukk</span>
                    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="#005782" d="M8,0 C8.55228475,0 9,0.3581722 9,0.8 L9,7 L15.2,7 C15.6418278,7 16,7.44771525 16,8 C16,8.55228475 15.6418278,9 15.2,9 L9,9 L9,15.2 C9,15.6418278 8.55228475,16 8,16 C7.44771525,16 7,15.6418278 7,15.2 L6.999,9 L0.8,9 C0.3581722,9 0,8.55228475 0,8 C0,7.44771525 0.3581722,7 0.8,7 L6.999,7 L7,0.8 C7,0.3581722 7.44771525,0 8,0 Z"></path></svg>
                </button>
            </div>
            <div class="menu-container">
                <WpNavi class="main-menu" location="main-menu"></WpNavi>
                
                <WpNavi class="secondary-menu" location="secondary-menu"></WpNavi>

                <div class="footer-social">
                    <SocialLinks />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SocialLinks from '@/components/elements/SocialLinks';
import WpNavi from '@/components/elements/WpNavi';

export default {
    name: 'side-menu',
    
    data(){
        return{
            wpvue : window.WPVUE,
        }
    },
    methods:{
        ...mapMutations([
            'MENU_OPEN_CHANGE_STATE'
        ]),
        closeMenu(){
            this.MENU_OPEN_CHANGE_STATE()
        }
    },
    computed:{
        ...mapGetters([
        ])
    },
    components:{
        SocialLinks,
		WpNavi,
    }
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.side-menu{
    .menu-container{
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 90vh; 
    }
    .footer-social{
        margin-top: 80px;
        @include mquery($tablet){
            margin-top: 40px;
        }
        @include mquery($phone){
            margin-top: 30px;
            svg{
                margin-left: 5px;
                margin-right: 5px;
            }
        }
        .social-links-block{
            margin-left: -5px;
            margin-right: -5px;
            svg{
                width: 40px;
                height: 40px;
                @include mquery($tablet){
                    width: 30px;
                    height: 30px;
                }
                @include mquery($phone){
                    width: 25px;
                    height: 25px;
                }
                path{
                    fill: $darkLight;
                }
            }
            .links{
                li{
                    margin-left: 5px;
                    margin-right: 5px;
                }
            }
        }
    }
    .menu{
        margin-top: 40px;
        @include mquery($tablet){
            margin-top: 30px;
        }
        @include mquery($phone){
            margin-top: 20px;
        }
        .wp-navi-links{
            margin: 0;
            padding: 0;
            .link-list{
                list-style: none;
                a.link-navi{
                    color: $darkLight;
                    margin-bottom: 12px;
                    display: inline-block;
                    text-decoration: none;
                    @include mquery($phone){
                        margin-bottom: 8px;
                    }
                }
            }
           
        }
        &.main-menu{
            margin-top: 85px;
            @include mquery($tablet){
                margin-top: 60px;
            }
            @include mquery($phone){
                margin-top: 30px;
            }
            .link-list{
                a.link-navi{
                    font-weight: 700;
                    margin-bottom: 20px;
                    @include mquery($phone){
                        margin-bottom: 10px;
                    }
                    @include fluid-type($smallResText, $wideResText, 16px, 25px);
                }
            }
        }
    }
    

}
</style>